import type React from "react";
import { Button } from "../ui/button";
import { FcGoogle } from "react-icons/fc";
import { useAuth } from "@/hooks/useAuth";
import { useToast } from "@/hooks/ui/use-toast";

interface GoogleAuthButtonProps {
	mode: "login" | "signup";
}

const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({ mode }) => {
	const { loginWithGoogle, loading } = useAuth();
	const { toast } = useToast();

	const handleGoogleAuth = async () => {
		try {
			await loginWithGoogle();
			// リダイレクトはuseAuthRedirectで処理されるため、ここでは何もしない
		} catch (err) {
			toast({
				title: "エラー",
				description: "認証に失敗しました。もう一度お試しください。",
				variant: "destructive",
			});
		}
	};

	return (
		<Button
			variant="outline"
			className="w-full"
			onClick={handleGoogleAuth}
			disabled={loading}
		>
			<FcGoogle className="mr-2 h-4 w-4" />
			Googleで{mode === "login" ? "ログイン" : "登録"}
		</Button>
	);
};

export default GoogleAuthButton;
